module.exports = __webpack_public_path__ + "static/media/draw-tutorial-1.f01cbdb8.svg";